<div>
  <app-center-section #productContent>
    @if (product) {
      <app-image-carousel [product]="product"></app-image-carousel>
      <div class="product-details">
        <section class="product-header">
          <div class="product-summary">
            @if (!product.forSale && product.notForSaleDescription) {
              <div [innerHTML]="product.notForSaleDescription | sanitizeHtml" class="rich-text"></div>
            }
            <h1 class="product-details-name">{{ product.productDisplayTitle || product.productDisplayName }}</h1>
            @if (summaryLabel) {
              <span class="product-details-summary">{{ summaryLabel }}</span>
            }
            @if (!product.altPriceText) {
              <app-price [value]="price" class="price-text" [forceSuperscript]="true"></app-price>
            }
            <div class="discount-levels">
              @for (discountLevel of product.discountLevels; track discountLevel.id) {
                <div>
                  <span>{{ discountLevel.displayText }}</span>
                  @if (!discountLevel.hidePercentPerQuantity) {
                    <span> {{ discountLevel.discountPercent }}% for {{ discountLevel.minimumQuantity }} stk. </span>
                  }
                </div>
              }
            </div>
            @if (product.altPriceText) {
              <span class="price-text">{{ product.altPriceText }}</span>
            }
            @if (product.splash && product.originalPrice !== product.price) {
              <span class="product-card-original-price">
                {{ originalPriceLabel }} {{ product.originalPrice | number: '.2-2' : locale }}
              </span>
            }
            @if (product.infoText) {
              <span class="product-info-text">{{ product.infoText }}</span>
            }
          </div>
          <div class="product-buttons">
            @let entry = isProductLine((basketProducts | async)[product.id]);
            @if (!entry && !product.isAdvertisement) {
              <app-text-button class="basket-button" [disabled]="!product.forSale" (click)="addToBasket()">
                {{
                  product.forSale
                    ? product.productPageButtonText
                      ? product.productPageButtonText
                      : sharedContent.addToBasketLabel
                    : sharedContent.productNotForSale
                }}
              </app-text-button>
            }
            @if (entry && !product.isAdvertisement) {
              <app-counter
                class="basket-button"
                [count]="entry.quantity"
                [minCount]="product.minCount"
                [packageOptions]="product.packageOptions"
                (add)="addProduct($event.quantity, $event.packageOptions)"
                (remove)="removeProduct(entry.quantity, $event.quantity, $event.packageOptions)"
              ></app-counter>
            }
            @if (product.isAdvertisement) {
              <app-text-button [disabled]="!product.forSale" class="basket-button" [routerLink]="contactUsUrl">
                {{ sharedContent.contactUs }}
              </app-text-button>
            }

            @if (product.alcoholPercent) {
              <img
                src="assets/images/sundhedsstyrelsen.png"
                alt="Aldersgrænse for salg: 16 år for alkohol under 16,5% og 18 år for alkohol fra 16,5%"
                class="age-restricted"
              />
            }
          </div>
        </section>
        <section #productDescription class="product-descriptions">
          @if (!product.productDeliveryLimit?.hidden && product.productDeliveryLimit; as deliveryLimit) {
            <div class="delivery-limit">
              @if (product | limit; as interval) {
                <mat-icon svgIcon="info"></mat-icon>
                @if (interval.from === interval.to) {
                  <span>Udleveres næste gang {{ interval.from | date: 'fullDate' }}</span>
                }
                @if (interval.from !== interval.to) {
                  <span> Udleveres næste gang mellem {{ interval.from | date: 'fullDate' }} og {{ interval.to | date: 'fullDate' }} </span>
                }
              }
            </div>
          }
          @if (product.productDescription) {
            @if (product.productDisplayTitle) {
              <h2>{{ product.productDisplayName }}</h2>
            }
            <div [innerHTML]="product.productDescription | sanitizeHtml" class="rich-text"></div>
          }

          <div class="expanded-description">
            @for (descriptionExtension of product.descriptionExtensions; track descriptionExtension.index) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    @if (descriptionExtension.icon) {
                      <mat-icon>{{ descriptionExtension.icon }}</mat-icon>
                    }
                    <h2>{{ descriptionExtension.title }}</h2>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div [innerHTML]="descriptionExtension.content | sanitizeHtml" class="rich-text"></div>
              </mat-expansion-panel>
            }

            @if (product.allergens?.length > 0) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h2>Allergener</h2>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="allergener">
                  <span><mat-icon svgIcon="warning"></mat-icon>{{ getAllergensString(product.allergens) }}</span>
                </div>
              </mat-expansion-panel>
            }

            @if (product.alcoholPercent) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h2>Alkoholprocent</h2>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="alcohol">
                  <span>{{ product.alcoholPercent }} %</span>
                </div>
              </mat-expansion-panel>
            }

            @if (product.ingredients) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h2>Ingredienser</h2>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="ingredients">
                  <p>{{ product.ingredients }}</p>
                </div>
              </mat-expansion-panel>
            }

            @if (product.nutrients?.length) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <h2>Næringsindhold</h2>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <app-nutritional-content [content]="product.nutrients"></app-nutritional-content>
              </mat-expansion-panel>
            }
          </div>

          @if (product.displayPdfUrls && product.pdfUrls?.length > 0) {
            <div class="pdfs">
              <h2>{{ preparationGuideLabel }}</h2>
              <div class="pdflinks-wrapper">
                @for (pdfurl of product.pdfUrls; track pdfurl) {
                  @let label = pdfurl | pdfName;
                  @if (!kioskService.isKiosk) {
                    <app-text-button target="_blank" [href]="pdfurl">
                      {{ label }}
                    </app-text-button>
                  } @else {
                    <app-text-button target="_blank" (click)="openLinkDialog(label, pdfurl)">
                      {{ label }}
                    </app-text-button>
                  }
                }
              </div>
            </div>
          }
        </section>
      </div>
    }
  </app-center-section>

  @if (strips?.length) {
    <app-strip-container [strips]="strips"></app-strip-container>
  }

  @for (productAddition of product.productAdditions; track productAddition.id) {
    @if (productAddition.display) {
      <app-product-additions [additions]="productAddition"></app-product-additions>
    }
  }
</div>
